import React from 'react';
import './banner.css';

function Banner() {
    return (
        <div id="banner">
            <div className="container">
                <div id="stageWrap">
                    <div id="stage">
                        <div id="shape" className="ring">
                            <div className="plane one"></div>
                            <div className="plane_mobile plane two"></div>
                            <div className="plane_mobile plane three"></div>
                            <div className="plane_mobile plane four"></div>
                            <div className="plane_mobile plane five"></div>
                            <div className="plane_mobile plane six"></div>
                            <div className="plane_mobile plane seven"></div>
                            <div className="plane_mobile plane eight"></div>
                            <div className="plane_mobile plane nine"></div>
                            <div className="plane_mobile plane ten"></div>
                            <div className="plane_mobile plane eleven"></div>
                            <div className="plane_mobile plane twelve"></div>
                        </div>
                    </div>
                </div>

                <div className="toptitle"></div>
                <div className="secondtitle">快速了解屬於您的權益福利！</div>
                <p>遊戲酒吧為VIP設計各項活動並不定期提升VIP福利，要讓酒吧VIP享有獲得最好的服務</p>
            </div>
        </div>
    );
}

export default Banner;


// WEBPACK FOOTER //
// ./src/containers/home/banner.jsx